@if (!errorType) {
<tec-pwcs-layout
    [ngClass]="{ dark: designService.isDarkMode() }"
    [subtitle]="tutorial || showIbanForm || showNameForm ?
        (`CONNECTIONS.BANK_SCORING.TUTORIAL_TITLE${operation.config.evaluation === EVALUATION_TYPE.MATCH_DATA ? '_MATCH' : ''}` | translate) :
        ('CONNECTIONS.BANK_SCORING.TITLE' | translate)"
    [footerLabel]="tutorial || showIbanForm || showNameForm ? ('GENERAL.TUTORIAL_CONNECTION_ENCRYPTION' | translate) : ''">

    <tec-progress [value]="progressService.getValue()"></tec-progress>

    <ng-container content>
        @if (tutorial) {
            <pwcs-inline-svg
                [src]="'assets/images/connection-tutorial' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                idSuffix="bank-scoring-connection-tutorial"
            />
        } @else if (showIbanForm) {
            <tec-tile class="custom-tile">
                <tec-form-group [label]="'CONNECTIONS.BANK_SCORING.FORM.IBAN' | translate"
                    [errorMsg]="reactiveFormService.hasMsgError(formIban)">
                    <tec-input
                        [formControl]="formIban"
                        [placeholder]="'CONNECTIONS.BANK_SCORING.FORM.IBAN_PLACEHOLDER' | translate"
                        [hasError]="reactiveFormService.hasError(formIban)"
                    ></tec-input>
                </tec-form-group>
            </tec-tile>
        } @else if (showNameForm) {
            <tec-tile [formGroup]="formName" class="custom-tile">
                <div class="grid grid-e2-sm">
                    <tec-form-group [label]="'CONNECTIONS.BANK_SCORING.FORM.NAME' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(formName.get('name'))">
                        <tec-input
                            formControlName="name"
                            [placeholder]="'CONNECTIONS.BANK_SCORING.FORM.NAME_PLACEHOLDER' | translate"
                            [hasError]="reactiveFormService.hasError(formName.get('name'))"
                        ></tec-input>
                    </tec-form-group>
                    <tec-form-group [label]="'CONNECTIONS.BANK_SCORING.FORM.SURNAME' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(formName.get('surname'))">
                        <tec-input
                            formControlName="surname"
                            [placeholder]="'CONNECTIONS.BANK_SCORING.FORM.SURNAME_PLACEHOLDER' | translate"
                            [hasError]="reactiveFormService.hasError(formName.get('surname'))"
                        ></tec-input>
                    </tec-form-group>
                </div>
            </tec-tile>
        }
    </ng-container>

    <ng-container actions>
        @if (tutorial) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="startBankConnection()"
            ></tec-button>
        } @else if (showIbanForm) {
            <tec-button
                [type]="'default'"
                [size]="'lg'"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="validateIbanAndGenerateUrl()"
            ></tec-button>
        } @else if (showNameForm) {
            <tec-button
                [type]="'default'"
                [size]="'lg'"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="validateNameAndGetScoring()"
            ></tec-button>
        }
    </ng-container>
</tec-pwcs-layout>
}

<!-- ERRORS -->
@if (errorType) {
<tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode()}">
    <ng-container content>
        @switch (errorType) {
            @case ('IBAN_NOT_FOUND') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.IBAN_NOT_FOUND_TITLE' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('CONSENT_NOT_FOUND') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.CONSENT_NOT_FOUND_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.BANK_SCORING.ERROR.CONSENT_NOT_FOUND_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('TOKEN_NOT_FOUND') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.TOKEN_NOT_FOUND_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.BANK_SCORING.ERROR.TOKEN_NOT_FOUND_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('NAME_NOT_FOUND') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.NAME_NOT_FOUND_TITLE' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('BANK_NOT_FOUND') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.BANK_NOT_FOUND_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.BANK_SCORING.ERROR.BANK_NOT_FOUND_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('USER_REJECTED') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.USER_REJECTED_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.BANK_SCORING.ERROR.USER_REJECTED_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
            @case ('SERVER') {
                <tec-tile
                    type="status"
                    [title]="'CONNECTIONS.BANK_SCORING.ERROR.SERVER_TITLE' | translate"
                    [subtitle]="'CONNECTIONS.BANK_SCORING.ERROR.SERVER_DESCRIPTION' | translate"
                    tagIconStatus="default"
                    icon="icon-alert"
                ></tec-tile>
            }
        }
    </ng-container>
    <ng-container actions>
        @switch (errorType) {
           @case ('IBAN_NOT_FOUND') {
                @if (numberOfTries < operation.config?.total_tries) {
                <!-- <tec-button
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ADD_IBAN' | translate"
                    (clickEvent)="ibanForm()"
                ></tec-button> -->
                }
            }
            @case ('CONSENT_NOT_FOUND') {
                @if (numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="generateUrl()"
                ></tec-button>
                }
            }
            @case ('TOKEN_NOT_FOUND') {
                @if (numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="getScoring()"
                ></tec-button>
                }
            }
            @case ('NAME_NOT_FOUND') {
                @if (numberOfTries < operation.config?.total_tries) {
                <!-- <tec-button
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.ADD_NAME' | translate"
                    (clickEvent)="nameForm()"
                ></tec-button> -->
                }
            }
            @case ('BANK_NOT_FOUND') {
                @if (numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="getScoring()"
                ></tec-button>
                }
            }
            @case ('USER_REJECTED') {
                @if (numberOfTries < operation.config?.total_tries) {
                <tec-button
                    [type]="'default'"
                    [size]="'lg'"
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    (clickEvent)="generateUrl()"
                ></tec-button>
                }
            }
        }
    </ng-container>
</tec-pwcs-layout>
}
